/* eslint-disable */
/*global google*/
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
// import {GoogleApiWrapper, InfoWindow, Map, Marker, Polyline} from 'google-maps-react';
import jMoment from 'moment-jalali'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import {Map, Marker, TileLayer, Popup, Polyline} from 'react-leaflet'
import {guide} from '../mapComponents/guide'
import {divIcon} from 'leaflet'
import {renderToStaticMarkup} from 'react-dom/server'
class LastRouteDriver extends React.Component {
  constructor(props) {
    super(props)
    console.log(props)
    this.state = {
      position: [],
      driverName: '',
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      height: 25,
      width: 20
    }
  }

  componentDidMount() {
    var {personId} = this.props.match.params
    let data = {
      driverId: personId
    }

    http
      .post(`retail/manage/trajectory/driver/current`, data, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            position: response.data.object.locations,
            driverName: response.data.object.firstName + ' ' + response.data.object.lastName
          })
        } else {
          // message.error(response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  onMarkerClick(props, marker, e) {
    console.log(marker)
    console.log(props)
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    })
  }

  getMarkers() {
    let points = this.state.position
    const array = []
    points.forEach((item) => {
      if (item.lat && item.lon) {
        array.push({
          location: [item.lat, item.lon],
          ...item
        })
      }
    })
    return array
  }

  changeColorMarker = (state, hour) => {
    var icon
    if (state === 100) {
      switch (hour) {
        case '00':
        case '01':
        case '02':
        case '03':
        case '04':
        case '05':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/24-06.png')} height={this.state.height} width={this.state.width} />
          )
          break
        case '06':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/06-07.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/06-07.png");
          break
        case '07':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/07-08.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/07-08.png");
          break
        case '08':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/08-09.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/08-09.png");
          break
        case '09':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/09-10.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/09-10.png");
          break
        case '10':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/10-11.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/10-11.png");
          break
        case '11':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/11-12.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/11-12.png");
          break
        case '12':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/12-13.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/12-13.png");
          break
        case '13':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/13-14.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/13-14.png");
          break
        case '14':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/14-15.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/14-15.png");
          break
        case '15':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/15-16.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/15-16.png");
          break
        case '16':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/16-17.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/16-17.png");
          break
        case '17':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/17-18.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/17-18.png");
          break
        case '18':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/18-19.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/18-19.png");
          break
        case '19':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/19-20.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/19-20.png");
          break
        case '20':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/20-21.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/20-21.png");
          break
        case '21':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/21-22.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/21-22.png");
          break
        case '22':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/22-23.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/22-23.png");
          break
        case '23':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/23-24.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/23-24.png");
          break
        default:
          icon = renderToStaticMarkup(
            <img src={require('../../image/miniLoc.png')} height={this.state.height} width={this.state.width} />
          )
        //   icon = require("../../image/miniLoc.png");
      }
      return icon
    } else {
      switch (hour) {
        case '00':
        case '01':
        case '02':
        case '03':
        case '04':
        case '05':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/24-06.png')} height={this.state.height} width={this.state.width} />
          )
          break
        case '06':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/06-07.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/06-07.png");
          break
        case '07':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/07-08.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/07-08.png");
          break
        case '08':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/08-09.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/08-09.png");
          break
        case '09':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/09-10.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/09-10.png");
          break
        case '10':
          icon = renderToStaticMarkup(
            <img
              src={require('../../pin-white/10-11.png')}
              height={this.state.height}
              width={this.state.width}
              style={{marginBottom: '10px'}}
            />
          )
          //   icon = require("../../pin-white/10-11.png");
          break
        case '11':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/11-12.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/11-12.png");
          break
        case '12':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/12-13.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/12-13.png");
          break
        case '13':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/13-14.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/13-14.png");
          break
        case '14':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/14-15.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/14-15.png");
          break
        case '15':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/15-16.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/15-16.png");
          break
        case '16':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/16-17.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/16-17.png");
          break
        case '17':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/17-18.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/17-18.png");
          break
        case '18':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/18-19.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/18-19.png");
          break
        case '19':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/19-20.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/19-20.png");
          break
        case '20':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/20-21.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/20-21.png");
          break
        case '21':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/21-22.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/21-22.png");
          break
        case '22':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/22-23.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/22-23.png");
          break
        case '23':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/23-24.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/23-24.png");
          break
        default:
          icon = renderToStaticMarkup(
            <img src={require('../../image/miniLoc.png')} height={this.state.height} width={this.state.width} />
          )
        //   icon = require("../../image/miniLoc.png");
      }
      return icon
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  render() {
    const style = {
      width: '100%',
      height: '400px',
      margin: 'auto',
      position: 'relative !important'
    }

    var {position, driverName} = this.state
    let {name} = this.props.match.params
    for (let i = 0; i < position.length; i++) {
      // final[i]['timestamp']=undefined
      position[i]['lat'] = position[i]['lat']
      position[i]['lng'] = position[i]['lon']
    }
    return (
      <div className="rtl">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>توزیع</Link>
            </li>
            <li>پلن های توزیع</li>
            <li>رساننده های انتصابی</li>
            <li>آخرین مسیر {name}</li>
          </ul>
          <div className="filterComponent" style={{display: 'block'}}>
            <div className="d-flex">
              {guide.map((item, index) => (
                <div className="formComponent guide">
                  <p>{item.title}</p>
                  {item.url}
                </div>
              ))}
            </div>
          </div>
          <div className="addressMap">
            <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px'}}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {this.getMarkers().map((item, index) => (
                <Marker
                  icon={divIcon({
                    html: this.changeColorMarker(item.state, this.convertDigit(jMoment(item.timestamp).format('HH')))
                  })}
                  position={item.location}
                >
                  <Popup>
                    <div className="text-center">{this.state.driverName}</div>
                    <div className="text-center">سرعت :‌ {item.speed + ' کیلومتر بر ساعت '}</div>
                    <div className="text-center">
                      {item.timestamp && jMoment(item.timestamp).format('jYYYY/jMM/jDD HH:mm')}
                    </div>
                  </Popup>
                </Marker>
              ))}
              <Polyline positions={this.getMarkers()} />
            </Map>

            {/* <Map
                            google={this.props.google}
                            onClick={this.onMapClicked}
                            zoom={11}
                            style={style}
                            initialCenter={{
                                lat: 35.6892,
                                lng: 51.3890
                            }}
                        >
                            {this.state.position.map((marker, index) => (
                                <Marker
                                    name={marker.timestamp}
                                    icon={require('../../image/miniLoc.png')}
                                    key={`marker${index}`}
                                    onClick={this.onMarkerClick.bind(this)}
                                    position={{lat: marker.lat, lng: marker.lon}}
                                />
                            ))}

                            <Polyline
                                path={position}
                                strokeColor="#000"
                                strokeOpacity={0.4}
                                strokeWeight={2}/>

                            <InfoWindow
                                marker={this.state.activeMarker}
                                visible={this.state.showingInfoWindow}>
                                <p className='mapinfoWindow'>{this.state.selectedPlace.name == null ? '-' : jMoment(this.state.selectedPlace.name).format('jYYYY/jMM/jDD HH:mm:ss')}</p>
                            </InfoWindow>

                        </Map> */}
          </div>
        </div>
      </div>
    )
  }
}

//
export default LastRouteDriver
